<template>
	<v-app-bar
		v-if="isAuthenticated"
		data-test="appBar"
		density="compact"
		class="bg-nav text-primary"
		order="1"
		app
	>
		<template #prepend>
			<v-btn
				v-if="$vuetify.display.smAndUp"
				icon
				style="opacity: 0.5"
				data-tour="navRailToggle"
				@click.stop="miniVariant = !miniVariant"
			>
				<v-icon size="x-small"
					>{{
						!miniVariant
							? 'fa-solid fa-chevron-left'
							: 'fa-solid fa-chevron-right'
					}}
				</v-icon>
			</v-btn>
			<v-btn
				v-else
				class="me-2"
				icon="fa-solid fa-ellipsis-vertical"
				data-test="appBar__drawer-btn"
				data-tour="navToggle"
				@click.stop="drawerVisible = !drawerVisible"
			>
			</v-btn>
		</template>
		<span v-if="!isPROD">
			{{ $vuetify.display.name }}:
			{{ windowSize.width }}
		</span>

		<!--		<OfflineSync v-if="!isPROD"></OfflineSync>-->
		<ButtonIcon
			v-if="!isOnline"
			color="warning"
			notext
			icon="fa-solid fa-wifi-slash"
			:tooltip="{
				text: 'Sie sind offline. Einige Funktionen sind nicht verfügbar.',
				bottom: true,
			}"
		/>
		<v-spacer />
		<!-- AAR-1805: Auf xs ist die Leiste bei 375px randvoll (gemessen: 375 von
		     375px belegt). Ein weiteres Icon schoebe das Profilmenue heraus,
		     deshalb dort stattdessen der Eintrag im Profilmenue. -->
		<MaintenanceNoticeButton v-if="$vuetify.display.smAndUp" />
		<HelpButton v-if="$vuetify.display.smAndUp" />
		<ReportButton
			v-if="!settingsStore.data.hide_report"
			data-test="appBar__report-btn"
		/>
				<NotificationMenu
			v-if="checkIfSubscribedTo(routesLimited.subModules.notifications).allowed"
		/>
		<v-btn v-else stacked>
			<LockBadge :visible="true" un-bordered>
				<v-icon icon="fa-solid fa-bell" disabled size="small"></v-icon>
			</LockBadge>
		</v-btn>
		<AdminMenu v-if="canSettings"></AdminMenu>
		<ProfileButton></ProfileButton>
	</v-app-bar>
</template>

<script>
import NotificationMenu from 'elements/Notifications/NotificationMenu.vue'
import Notifications from './Notifications'
import ReportButton from 'components/templates/Buttons/ReportButton'
import LockBadge from 'components/templates/Badges/LockBadge'
import routesLimited from '@/constants/routesLimited'
import { useNavStore, useUserStore } from '@/stores/system'
import { useWindowSize } from '@vueuse/core'
import { storeToRefs } from 'pinia'
import { useSettingStore } from '@/stores/modules/setting'
import ProfileButton from '@/components/elements/ProfileButton.vue'
import HelpButton from '@/components/elements/HelpButton.vue'
import MaintenanceNoticeButton from '@/components/elements/MaintenanceNoticeButton.vue'
import { useSubscription } from '@/composables/subscription'
import { useLightOrDark } from '@/composables/useLightOrDark'
/*import OfflineSync from 'components/modules/OfflineSync.vue'*/
import AdminMenu from '../templates/AdminMenu.vue'

export default {
	name: 'Toolbar',
	components: {
		/*OfflineSync,*/
		ProfileButton,
		HelpButton,
		MaintenanceNoticeButton,
		Notifications,
		NotificationMenu,
		ReportButton,
		LockBadge,
		AdminMenu,
	},
	props: {
		drawer: {
			default: false,
			required: true,
			type: Boolean,
		},
		mini: {
			default: false,
			required: true,
			type: Boolean,
		},
	},
	emits: ['update:drawer', 'update:mini'],
	setup() {
		const { routeHistory: storeRouteHistory } = storeToRefs(useNavStore())
		const { checkIfSubscribedTo } = useSubscription()
		const { lightOrDark } = useLightOrDark()
		const { isOnline, canSettings } = storeToRefs(useUserStore())

		return {
			storeRouteHistory,
			checkIfSubscribedTo,
			lightOrDark,
			isOnline,
			canSettings,
		}
	},
	data: () => ({
		routesLimited,
		breadcrumps: [],
		useSearch: null,
		searchFocus: false,
		searchValue: '',
		navigated: 0,
		settingsStore: useSettingStore(),
		isAuthenticated: useUserStore().isLoggedIn,
		isPROD: import.meta.env.PROD,
		windowSize: useWindowSize(),
	}),
	computed: {
		routeHistory() {
			return this.storeRouteHistory
		},
		previousRoute() {
			return this.routeHistory.length > 1
				? this.routeHistory[this.routeHistory.length - this.navigated - 1]
				: undefined
		},
		nextRoute() {
			return this.routeHistory.length > 1
				? this.routeHistory[this.routeHistory.length - this.navigated + 1]
				: undefined
		},
		miniVariant: {
			get() {
				return this.mini
			},
			set(value) {
				this.$emit('update:mini', value)
			},
		},
		drawerVisible: {
			get() {
				return this.drawer
			},
			set(value) {
				this.$emit('update:drawer', value)
			},
		},
	},
	methods: {
		navigate(prev = true) {
			this.$router
				.push(prev ? this.previousRoute : this.nextRoute)
				.catch(() => {})
			this.navigated += 1
		},
	},
}
</script>

<style lang="scss"></style>
